import { useMutation, useQueryClient } from "react-query";

import axios, { AxiosError } from "axios";

import { SYNC_SVC_ADDRESS } from "../../../constants/app.constants";

const API_URL = `${SYNC_SVC_ADDRESS}/api/stick-sync`;

export interface CreatePadRequest {
  schema: string;
  projectId: string;
}

export interface CreatePadResponse {
  success: boolean;
  message: string;
}

const createPadScenario = async (
  request: CreatePadRequest
): Promise<CreatePadResponse> => {
  const response = await axios.post<CreatePadResponse>(API_URL, {
    schema: request.schema,
    projectId: request.projectId
  });

  return response.data;
};

export const useSyncSticks = () => {
  const queryClient = useQueryClient();

  return useMutation<CreatePadResponse, AxiosError, CreatePadRequest>(createPadScenario, {
    onSuccess: () => {
      // Invalidate relevant queries after successful pad creation
      queryClient.invalidateQueries(["scenarioFields"]);
    }
  });
};
